import React, { useState, useEffect } from "react";
import { Column } from "@ant-design/charts";

export default function UtilizationsIpVisits() {
  var data = [
    {
      type: "Hispanic or Latino",
      sales: 38,
    },
    {
      type: "Non-Hispanic or Latino",
      sales: 52,
    },
  ];

  var config = {
    data: data,
    height: 350,
    xField: "type",
    yField: "sales",
    color: "rgb(52, 181, 191)",

    label: {
      position: "middle",
      style: {
        fill: "rgb(52, 181, 191)",
        opacity: 0.6,
      },
    },
    xAxis: {
      label: {
        autoHide: true,
        autoRotate: false,
      },
    },
    meta: {
      type: { alias: "Average" },
      sales: { alias: "Average" },
    },
  };

  return (
    <div>
      <h5 style={{ textAlign: "center" }}> Ethnicity Distribution</h5>
      <Column {...config} />
    </div>
  );
}
